import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import React from "react";
import {
  iconButtonStyles,
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import { inputStyles } from "../../../../../Constants/inputStyles";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ResetUserPasswordDialog = ({
  openEditPasswordDialog,
  showNewPassword,
  editingUserPasswordState,
  toggleShowNewPassword,
  showNewPasswordReset,
  toggleShowNewPasswordReset,
  handlePasswordChange,
  handlePasswordReset,
  handlePwdClose,
}) => {
  return (
    <Dialog
      open={openEditPasswordDialog}
      // onClose={handlePwdClose}
      PaperProps={{
        sx: dialogStyles.dialogTitle,
      }}
      BackdropProps={{ invisible: true }}
      disableEscapeKeyDown
      fullWidth
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>Reset Password</DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <TextField
          autoFocus
          margin="dense"
          name="newPassword"
          placeholder="New Password"
          type={showNewPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={editingUserPasswordState.newPassword}
          onChange={handlePasswordChange}
          sx={inputStyles.textField}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={toggleShowNewPassword}
                edge="end"
                sx={iconButtonStyles}
              >
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <TextField
          margin="dense"
          name="confirmNewPassword"
          placeholder="Confirm New Password"
          type={showNewPasswordReset ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={editingUserPasswordState.confirmNewPassword}
          onChange={handlePasswordChange}
          sx={{ ...inputStyles.textField, mb: 2 }}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={toggleShowNewPasswordReset}
                edge="end"
                sx={iconButtonStyles}
              >
                {showNewPasswordReset ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={handlePwdClose} sx={textButtonStyles}>
          Cancel
        </Button>
        <Button
          onClick={handlePasswordReset}
          sx={primaryButtonStyles}
          disabled={
            !editingUserPasswordState.newPassword ||
            !editingUserPasswordState.confirmNewPassword ||
            editingUserPasswordState.newPassword !==
              editingUserPasswordState.confirmNewPassword
          }
        >
          Reset Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetUserPasswordDialog;
